import React, { FunctionComponent, memo, useContext } from 'react';
import FinanceCalculatorWidget from '../../../../common/components/financeCalculator/FinanceCalculatorWidget';
import Loader from '../../../../common/components/presentation/Loader';
import { IFinCalcSpcInitConfig } from '../../../../common/react/useGetFinCalcSpcInitConfig';
import { VariantIdsOnPageContext } from '../../../../common/react/VariantIdsOnPageContext';
import { ICarDetails } from '../../../../../../common/model/ICarDetails';
import { useFinCalcCustomise } from '../../../react/useFinCalcCustomise';
import useGetPostCode from '../../../../common/react/useGetPostCode';

export interface IFinanceCalculatorCustomiseWidget {
  carConfiguration: ICarDetails | IFinCalcSpcInitConfig;
  toggleModal: (shouldOpen: boolean) => void;
}

const FinanceCalculatorCustomiseWidget: FunctionComponent<IFinanceCalculatorCustomiseWidget> = memo(props => {
  const { postInitialization, isDealLoading } = useFinCalcCustomise(props);
  const { variantIds } = useContext(VariantIdsOnPageContext);
  const postcode = useGetPostCode();
  const { carConfiguration } = props;
  const additionalVariantIds = variantIds.filter(variantId => variantId !== props.carConfiguration.detailsAggregated);

  if (isDealLoading) {
    return <Loader />;
  }

  return <FinanceCalculatorWidget {...{ carConfiguration, postInitialization, additionalVariantIds, postcode }} />;
});

export default FinanceCalculatorCustomiseWidget;
